import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { SectionCard } from "./SectionCard";
import { CompanyRow } from "./CompanyRow";
import { getCountryByCode } from "../../../../utils/Helper";

/* Businesses the user follows. */
export const FollowedCompanies = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const follows = userInfo?.companyFollow || [];

  return (
    <SectionCard title="Businesses You Follow" count={follows.length}>
      {follows.length === 0 ? (
        <div className="py-8 text-center">
          <p className="text-[14px] text-[var(--muted)] font-sans">
            Follow businesses and stay updated about any changes.
          </p>
          <Link
            to="/search"
            target="_blank"
            className="mt-4 inline-flex h-[42px] items-center rounded-lg border border-[var(--coral)] px-5 text-[14px] font-semibold text-[var(--coral)] transition-colors hover:bg-[var(--coral-soft)]"
          >
            Start Following
          </Link>
        </div>
      ) : (
        <>
          {/* Scrolls without a visible bar once the list runs long. */}
          <div className="u1-no-scrollbar -mx-3.5 mt-2 max-h-[320px] overflow-y-auto">
            {follows.map((item) => (
              <CompanyRow
                key={item.companyID?.companyID}
                name={item.companyID?.registered_company_name}
                location={getCountryByCode(item.companyID?.country_code)}
                to={`/search/${item.companyID?.companyID}`}
                target="_blank"
              />
            ))}
          </div>

          {/* The design's .add-tile: a dashed outline rather than a plain link,
              so it reads as a slot waiting to be filled. */}
          <Link
            to="/search"
            className="mt-3 flex w-full items-center gap-3.5 rounded-[14px] border-[1.5px] border-dashed border-[var(--dash-line)] px-4 py-[15px] text-left text-[15px] font-bold text-[var(--coral)] font-sans transition-colors hover:border-[var(--coral)] hover:bg-[var(--coral-soft)]"
          >
            <span
              aria-hidden="true"
              className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full bg-[var(--coral)] text-white"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
                <path d="M12 5v14M5 12h14" />
              </svg>
            </span>
            Follow more businesses
          </Link>
        </>
      )}
    </SectionCard>
  );
};

export default FollowedCompanies;
